import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	document
		.querySelectorAll('.main_menu .menu > .menu-item-has-children')
		.forEach(init_sub_menu);

	init_close_others();
}

function init_sub_menu(li) {
	let hover_timer = null;
	li.addEventListener('pointerenter', () => {
		clearTimeout(hover_timer);
		global_hooks.do('nav_menu/sub/before_open', li);
		li.classList.add('hover');
		global_hooks.do('nav_menu/sub/open', li);
	});

	li.addEventListener('pointerleave', () => {
		hover_timer = setTimeout(() => {
			li.classList.remove('hover');
		}, 400);
	});

	disable_link(li);
}

function disable_link(li) {
	const a = li.children[0];
	a.addEventListener('click', (e) => {
		e.preventDefault();
	});
}

function init_close_others() {
	let previous = null;

	const close_previous = () => {
		if (!previous) return;
		previous.classList.remove('hover');
		previous = null;
	};

	global_hooks.on('nav_menu/sub/before_open', (li) => {
		close_previous();
		previous = li;
	});

	global_hooks.on('mega_menu/open', close_previous);
}
